var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PendingList',{attrs:{"pending":_vm.pending,"loading":_vm.loading,"buttonLoading":_vm.buttonLoading},on:{"add-pending-item":_vm.addPendingItem,"delete-pending-item":_vm.deletePendingItem,"goal-entry-added":_vm.handleGoalEntryAdded}})}
var staticRenderFns = []

export { render, staticRenderFns }